import styled from 'styled-components';

export const Img = styled.img.withConfig({ componentId: 'sc-1hs9p02-0' })`
    display: block;
    max-width: 100%;
`;

export const ImgFullWidth = styled.img.withConfig({ componentId: 'sc-1hs9p02-1' })`
    display: block;
    width: 100%;
`;
